import { useRef } from "react";
import { useFrame } from "@react-three/fiber";
// import * as THREE from "three";

const Lights = () => {
  const blueLight = useRef();
  const cyanLight = useRef();
  const warmLight = useRef();

  useFrame(( state ) => {
    const t = state.clock.elapsedTime;

    // Slow breathing effect for AI glow
    if (blueLight.current) {
      blueLight.current.intensity = 2.5 + Math.sin(t * 0.8) * 0.4;
    }

    if (cyanLight.current) {
      cyanLight.current.intensity = 1.5 + Math.sin(t * 1.2) * 0.3;
    }

    if (warmLight.current) {
      warmLight.current.intensity = 0.8 + Math.sin(t * 0.6) * 0.15;
    }
  });

  return (
    <>
      {/* Main cinematic blue light */}
      <pointLight
        ref={blueLight}
        position={[0, 2, 3]}
        color="#2563eb"
        intensity={2.5}
        distance={12}
        decay={2}
      />

      {/* Cyan edge lighting */}
      <pointLight
        ref={cyanLight}
        position={[-4, 1, -2]}
        color="#06b6d4"
        intensity={1.5}
        distance={10}
        decay={2}
      />

      {/* Warm realistic rim light */}
      <pointLight
        ref={warmLight}
        position={[4, -1, 1]}
        color="#f59e0b"
        intensity={0.8}
        distance={8}
        decay={2}
      />

      {/* Large soft studio light */}
      <directionalLight position={[0, 5, 5]} intensity={1.2} color="#ffffff" />

      {/* Ambient fill */}
      <ambientLight intensity={0.25} color="#94a3b8" />

      {/* Soft hemisphere realism */}
      <hemisphereLight args={["#60a5fa", "#020617", 0.6]} />
    </>
  );
};

export default Lights;
